
const columns = [
    { name: "Nome da turma", value: "name", filter: true },
    { name: "Quant. de alunos", value: "studentsAverage", filter: false },
    { name: "Quant. de cursos", value: "coursesAverage", filter: false },
    { name: "Status", value: "status", filter: false },
  ];
  const actions = [
    {
      title: "Calendário",
      icon: "bi-calendar-event",
      type: "edit",
      style: "btn-simple",
      tooltip: "Editar",
    },
  ];
  export {columns, actions}